<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="companiesList">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Companies</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical>
          </v-divider>
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" @click="dialogAddNew=!dialogAddNew">Add</v-btn>
          <v-dialog v-model="dialogAddNew" max-width="500px">
            <v-card>
               <v-card-title>
                Add new Company
              </v-card-title>
              <v-card-text>
                <ValidationObserver ref="company" v-slot="{ invalid, valid, errors }">
                  <v-form v-model="isValid">
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-container>
                          <v-row>
                            <v-col>
                              <ValidationProvider
                                rules="required"
                                name="CompanyName"
                                vid="companyName"
                                v-slot="{ errors }">
                                <v-text-field
                                  v-model="editedItem.companyName"
                                  :error-messages="errors"
                                  maxlength="50"
                                  label="Company name"
                                  append-icon="mdi-card-bulleted-outline"
                                  placeholder="Enter company name">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <ValidationProvider
                                rules="required"
                                name="billingAddress"
                                vid="billingAddress"
                                v-slot="{ errors }">
                                <v-text-field
                                  v-model="editedItem.companyBillingAddress"
                                  :error-messages="errors"
                                  maxlength="250"
                                  label="Company billing address"
                                  append-icon="mdi-postage-stamp"
                                  placeholder="Enter company billing address">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <ValidationProvider
                                rules="required|min_value:0"
                                name="Discount $"
                                vid="companyDiscountDollars"
                                v-slot="{ errors }">
                                <v-currency-field
                                  :error-messages="errors"
                                  label="Discount $"
                                  v-model="editedItem.companyDiscountDollars"
                                  prefix="$"
                                  type="number"
                                  money="money"
                                  maxlength="5">
                                </v-currency-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <ValidationProvider
                                rules="required|min_value:0|max_value:100"
                                name="Discount %"
                                vid="companyDiscountPercent"
                                v-slot="{ errors }">
                                <v-currency-field
                                  :error-messages="errors"
                                  label="Discount %"
                                  v-model="editedItem.companyDiscountPercent"
                                  suffix="%"
                                  type="number"
                                  money="money"
                                  maxlength="5">
                                </v-currency-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-checkbox
                                label="Is Travel Agent"
                                v-model="editedItem.isTravelAgent" />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-checkbox
                                label="Is Allowed A/c"
                                v-model="editedItem.isAllowedAnAccount" />
                            </v-col>
                          </v-row>
                        </v-container>
                      </template>
                      <v-date-picker
                        v-model="newInvalidBookingDate"
                        @input="menu1 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-form>
                </ValidationObserver>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.isTravelAgent="{ item }">
        <v-simple-checkbox
          v-model="item.isTravelAgent"
          disabled>
        </v-simple-checkbox>
      </template>
      <template v-slot:item.isAllowedAnAccount="{ item }">
        <v-simple-checkbox
          v-model="item.isAllowedAnAccount"
          disabled>
        </v-simple-checkbox>
      </template>
      <template v-slot:item.companyDiscountDollars="{ item }">
        {{ item.companyDiscountDollars | toCurrency }}
      </template>
      <template v-slot:item.companyDiscountPercent="{ item }">
        {{ item.companyDiscountPercent | toPercentage(2, true) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)">
          mdi-pencil
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
/* eslint-disable camelcase */
import { required, min_value, max_value } from 'vee-validate/dist/rules';
/* eslint-enable camelcase */
import
{
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import storeConstants from '@/store/storeConstants';

setInteractionMode('eager');

extend('required', required);
extend('min_value', min_value);
extend('max_value', max_value);

export default {
  name: 'companies',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  directives: {
  },
  data: () => ({
    limitToCountries: ['AU'],
    newInvalidBookingDate: null,
    isValid: false,
    menu1: false,
    companiesList: [],
    dialogAddNew: false,
    defaultItem: {
      id: undefined,
      companyName: undefined,
      companyDiscountDollars: undefined,
      companyDiscountPercent: undefined,
      companyBillingAddress: undefined,
      isAllowedAnAccount: undefined,
      isTravelAgent: undefined,
      issuesTickets: undefined,
    },
    editedItemIndex: -1,
    editedItem: {},
    headers: [
      {
        text: 'Company Id',
        align: 'start',
        sortable: false,
        value: 'companyId',
      },
      {
        text: 'Company name',
        align: 'start',
        sortable: true,
        value: 'companyName',
      },
      {
        text: 'Discount $',
        align: 'start',
        sortable: true,
        value: 'companyDiscountDollars',
      },
      {
        text: 'Discount %',
        align: 'start',
        sortable: true,
        value: 'companyDiscountPercent',
      },
      {
        text: 'Travel Agent',
        align: 'start',
        sortable: true,
        value: 'isTravelAgent',
      },
      {
        text: 'Allowed A/c',
        align: 'start',
        sortable: true,
        value: 'isAllowedAnAccount',
      },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
  }),
  computed: {
    ...mapGetters([storeConstants.IS_ADMINISTRATOR, storeConstants.COMPANIES_ADMIN]),
    // The `mapFields` function takes an array of
    // field names and generates corresponding
    // computed properties with getter and setter
    // functions for accessing the Vuex store.
    ...mapFields([
    ]),
  },
  mounted() {
    this.retrieveCompanies();
  },
  methods: {
    ...mapActions([
      storeConstants.GET_COMPANIES_ADMIN,
      storeConstants.GET_COMPANY_ADMIN,
      storeConstants.SAVE_COMPANY_ADMIN]),
    retrieveCompanies() {
      this.GET_COMPANIES_ADMIN()
        .then(() => {
          this.companiesList = this.COMPANIES_ADMIN;
          this.isLoading = false;
        },
        (error) => {
          this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    close() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedItemIndex = -1;
      this.dialogAddNew = false;
    },
    save() {
      this.$refs.company.validate().then((success) => {
        this.isValid = success;
        if (this.isValid) {
          this.SAVE_COMPANY_ADMIN(this.editedItem)
            .then(() => {
              this.clearEditItem();
              this.companiesList = this.COMPANIES_ADMIN;
              this.dialogAddNew = false;
            },
            (error) => {
              this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        }
      });
    },
    clearEditItem() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedItemIndex = -1;
      });
    },
    editItem(item) {
      this.editedItemIndex = this.companiesList.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogAddNew = true;
    },
  },
};
</script>
